import { render } from "./BrevoForm.vue?vue&type=template&id=4e45006c&scoped=true"
import script from "./BrevoForm.vue?vue&type=script&lang=js"
export * from "./BrevoForm.vue?vue&type=script&lang=js"

import "./BrevoForm.vue?vue&type=style&index=0&id=4e45006c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e45006c"]])

export default __exports__